const bxfSparkle = {
    svg: '<svg style="flex-shrink: 0;forced-color-adjust: auto;fill: currentcolor; width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><path d="M11 4a7 7 0 0 1-7 7 7 7 0 0 1 7 7 7 7 0 0 1 7-7 7 7 0 0 1-7-7"/><path d="M17 14a3 3 0 0 1-3 3 3 3 0 0 1 3 3 3 3 0 0 1 3-3 3 3 0 0 1-3-3"/></svg>',
};

export { bxfSparkle as default };
